import { IdCodeDef } from "../type/idcode-def";
import { QueryDef } from "../type/query-def";

import { formatDatetimeWithoutTZ } from "../time-grain";

export class IdCodeAdapter {
  static toInputDTO(req: QueryDef): any {
    const subjectAttrs =
      req.subject_attrs?.map((attr: any) => ({
        id: attr.id,
        name: attr.key,
        options:
          attr.attrs
            ?.filter((option: any) => option.value)
            .map((option: any) => ({
              id: option.id,
              value: option.key,
            })) || [],
      })) || [];

    let subjectGroups: any[] | null = req.subject_groups || [];

    const isNoFilter = subjectGroups.some((group) =>
      group.attrs?.some(
        (option: any) => option.key === "no_filter" && option.value === true
      )
    );

    if (isNoFilter) {
      subjectGroups = null;
    } else {
      subjectGroups = subjectGroups.map((group: any) => ({
        id: group.id,
        name: group.key,
        options:
          group.attrs
            ?.filter(
              (option: any) =>
                option.key !== "no_filter" && option.value === true
            )
            .map((option: any) => ({
              id: option.id,
              value: option.key,
            })) || [],
      }));
    }

    const timeGrain = req.time_grain.find((t) => t.value)?.key || "one_day";

    return {
      subject_attrs: subjectAttrs,
      subject_groups: subjectGroups,
      // タイムゾーンをずらさずに送る。旧 formatUTCtoJSTWithoutTZ は +9h していたが、
      // backend の datetime は DWH のナイーブ値なので二重変換になり、終端が日跨ぎして
      // 存在しない tick を指していた (500 の直接原因)。
      time_range: {
        start: formatDatetimeWithoutTZ(req.time_range.start),
        end: formatDatetimeWithoutTZ(req.time_range.end),
      },
      is_noapps: req.is_noapps,
      time_granularity: timeGrain,
    };
  }

  static toOutputDTO(res: any): IdCodeDef {
    return { hash: res.hash };
  }
}
